import { useState } from "react";

const TimeRangeModal = ({ initialSlot, onClose, onSave }) => {
  const [start, setStart] = useState(initialSlot.startHour);
  const [end, setEnd] = useState(initialSlot.endHour);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center pt-24">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />

      <div className="relative w-72 bg-dry rounded-lg border border-yellowlight p-4 text-text">
        <div className="flex justify-between mb-4">
          <h3 className="text-sm font-semibold">Edit working time</h3>
          <button onClick={onClose}>✕</button>
        </div>

        <div className="space-y-3">
          <input
            type="number"
            value={start}
            onChange={(e) => setStart(+e.target.value)}
            className="w-full bg-dry border border-border rounded px-2 py-1"
          />
          <input
            type="number"
            value={end}
            onChange={(e) => setEnd(+e.target.value)}
            className="w-full bg-dry border border-border rounded px-2 py-1"
          />
        </div>

        <div className="flex justify-end mt-4">
          <button
            onClick={() => onSave({ startHour: start, endHour: end })}
            className="bg-yellowlight text-yellowdark px-3 py-1.5 rounded"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default TimeRangeModal;
